var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLimits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33 0c-.92 0-1.66.86-1.66 1.92h-5C.75 1.92 0 2.78 0 3.85 0 4.9.75 5.77 1.67 5.77h5c0 1.06.74 1.92 1.66 1.92.92 0 1.67-.86 1.67-1.92V1.92C10 .86 9.25 0 8.33 0zM23.33 10.58H20c0-1.07-.75-1.93-1.67-1.93-.92 0-1.66.86-1.66 1.93v3.84c0 1.07.74 1.93 1.66 1.93.92 0 1.67-.86 1.67-1.93h3.33c.92 0 1.67-.86 1.67-1.92s-.75-1.92-1.67-1.92zM23.33 1.92H12.5c-.92 0-1.67.86-1.67 1.93 0 1.06.75 1.92 1.67 1.92h10.83c.92 0 1.67-.86 1.67-1.92 0-1.07-.75-1.93-1.67-1.93zM14.17 10.58H1.67c-.92 0-1.67.86-1.67 1.92s.75 1.92 1.67 1.92h12.5c.92 0 1.66-.86 1.66-1.92s-.74-1.92-1.66-1.92zM23.33 19.23h-6.66c-.92 0-1.67.86-1.67 1.92 0 1.07.75 1.93 1.67 1.93h6.66c.92 0 1.67-.86 1.67-1.93 0-1.06-.75-1.92-1.67-1.92zM12.5 17.3c-.92 0-1.67.87-1.67 1.93H1.67c-.92 0-1.67.86-1.67 1.92 0 1.07.75 1.93 1.67 1.93h9.16c0 1.06.75 1.92 1.67 1.92.92 0 1.67-.86 1.67-1.92v-3.85c0-1.06-.75-1.92-1.67-1.92z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLimits);
export default ForwardRef;